<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('business.label.fieldInfo')" type="confirm" width="40%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="field" :rules="rules" :wrapper-col="wrapperCol">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.fieldNo')" prop="no">
            <vxe-input v-model="field.no" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.fieldName')" prop="name">
            <vxe-input v-model="field.name" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.fieldType')" prop="type">
            <vxe-input v-model="field.type" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.displayMode')" prop="displayMode">
            <vxe-input v-model="field.displayMode" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.alignment')" prop="alignment">
            <vxe-number-input v-model="field.alignment" :max="1" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import { findOne, save } from '@/api/Api'
import { Field } from '@/api/dto/admin/Field'

export default {
  name: 'FieldEditor',
  data() {
    return {
      visible: false,
      loading: false,
      field: new Field(),
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        no: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        type: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        displayMode: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  methods: {
    add() {
      this.visible = true
      this.field = new Field()
      this.field.available = true
    },
    edit(id, copy) {
      this.visible = true
      this.loading = true
      findOne('fieldFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.field = new Field(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const field = this.field.toJSONObject()
      field.dictionaries = []
      save('fieldPersister', field).then(res => {
        if (res.success) {
          this.field = new Field(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('success')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    }
  }
}
</script>